import { applyAccountRelatedClass } from './account-related/account-access.js'
import { applyPublicAccountFeatureClass } from './account-related/public-accounts.js'
import { applyAccountData } from './account-related/apply-account-data.js'
import { applyPreviewClass } from './previews/apply-preview-class.js'
import { applyLoggedInUserClass } from './user-related/apply-logged-in-user.js'
import { applyUserRights } from './user-related/apply-user-rights.js'

/**
 * Hide content
 * Classes which are managed:
 * :forPrivateAccount
 * :forPublicAccount
 * :needRights-canManage
 * @param {String} htmlContent
 * @param {Object} params
 * @param {Object} [params.browserAppUser]
 * @param {Object} [params.browserAppAccount]
 * @returns {String} updated HTML string
 */
export function applyHtmlRestrictions (htmlContent, params) {
  // console.log('applyHtmlRestrictions', params)
  if (!htmlContent) return

  const { browserAppUser, browserAppAccount } = params

  htmlContent = applyPublicAccountFeatureClass(htmlContent)
  htmlContent = applyAccountRelatedClass(htmlContent, browserAppAccount?.data?.appAccount)
  htmlContent = applyAccountData(htmlContent, browserAppAccount)

  htmlContent = applyLoggedInUserClass(htmlContent, browserAppUser?.data)
  htmlContent = applyUserRights(htmlContent, browserAppAccount)

  htmlContent = applyPreviewClass(htmlContent, browserAppUser?.data?.appUser)

  return htmlContent
}
